import axios from "axios";

export async function fetchCompanyTrailers(companyId) {
  const r = await axios.get(`/api/vehicle/all?type=trailer&company_id=${companyId}`);
  return r?.data?.data?.data ?? [];
}

export async function createTrailer(payload) {
  const r = await axios.post(`/api/vehicle`, payload);
  return r?.data?.data;
}

export async function updateTrailerById(id, payload) {
  await axios.patch(`/api/vehicle/${id}`, payload);
}

export async function updateQuoteWithTrailers(quoteId, wholeQuoteData) {
  await axios.patch(`/api/quote/${quoteId}`, {
    data: {
      quote: wholeQuoteData,
    },
  });
}
